import ActionEditorLink from './ActionEditorLink';

// Re-export the extracted modules so every existing
// `from ".../action-editor/ActionEditor"` import keeps working unchanged.
export * from './action-types';
export * from './action-defaults';
export * from './action-utils';

export default ActionEditorLink
